import React, { useState } from "react"
import { StyledArrow } from "Components/common/kcArrow"
import styled from "styled-components"

import Divider from "Components/common/divider"

const StyledDropdownWrapper = styled.div`
    width: 100%;
    max-height: ${(props) => (props.isOpen ? 100 : 1.7)}rem;
    overflow: hidden;
    transition: all 0.2s;
`

const StyledButton = styled.div`
    font-size: 0.9rem;
    color: ${(props) => props.theme.color.dimmerGrey};
    font-weight: 100;
    widht: 100%;
    height: 1.7rem;
    display: flex;
    align-items: center;
    &:hover {
        cursor: pointer;
        opactiy: 0.7;
    }
`

const StyledTitle = styled.div`
    flex: 1;
`

const StyledContent = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 1rem 0;
    opacity: ${(props) => (props.isOpen ? 1 : 0)};
    pointer-events: ${(props) => (props.isOpen ? "default" : "none")};
    transition: all 0.2s;
`

const KCRowDropdown = ({ title, isOpen, handlerOpen, children }) => {
    return (
        <>
            <StyledDropdownWrapper isOpen={isOpen}>
                <StyledButton onClick={() => handlerOpen(!isOpen)}>
                    <StyledTitle>{title}</StyledTitle>
                    <StyledArrow
                        size={2}
                        direction={isOpen ? "down" : "left"}
                    />
                </StyledButton>
                <StyledContent isOpen={isOpen}>{children}</StyledContent>
            </StyledDropdownWrapper>
            <Divider />
        </>
    )
}

export default KCRowDropdown
